import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../../SectionHeading';

const WorldSignalRo = () => (
  <section className="py-24 bg-brand-surface border-t border-white/5 relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))] from-blue-900/15 via-transparent to-transparent"></div>
    <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10">
      <SectionHeading title="Semnalul" subtitle="2514 · Pragul" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="space-y-6"
      >
        <p className="text-gray-300 leading-relaxed text-lg text-center">
          În <span className="text-brand-accent font-semibold">2514</span>, la unsprezece zile după ce Odiseea a traversat heliopauza, Observatorul Heliopausei din Neptun a detectat ceva ce nu ar fi trebuit să existe: un semnal din spațiul interstelar profund.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 my-8">
          {[
            { label: 'Recursiv', desc: 'Structură auto-referențială' },
            { label: 'Deliberat', desc: 'Densitatea informațională a unei minți' },
            { label: 'Antic', desc: 'Posibil vechi de milioane de ani' },
          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-brand-dark border border-blue-500/20 rounded-xl p-5 text-center"
            >
              <p className="text-blue-400 font-display font-bold text-lg mb-1">{item.label}</p>
              <p className="text-gray-500 text-sm">{item.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="bg-brand-dark border border-blue-500/20 rounded-2xl p-8">
          <p className="text-gray-300 italic leading-relaxed text-lg text-center">
            „Cronica se termină aici — deliberat. Următorul capitol este al nostru de scris."
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);

export default WorldSignalRo;